export function salaryCatsReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SALARY_CAT":            
        case "UPDATE_SALARY_CAT":
            let list = Object.assign({}, state);
            list[payload.salary_cat_id] = payload
        
            return list
            
        case "GET_SALARY_CATS":

            return payload
            
        default:
            return state;
    }
    
}